import Immutable from 'immutable';
import {
  CLEAR_ITINERARY_TOLL_LIQUIDATION,
  CLEAR_ITINERARY_TOLL_LIQUIDATION_DETAIL,
  CLEAR_TOLL_LIQUIDATION,
  CLEAR_TOLL_LIQUIDATIONS,
  FLAG_GETTING_TOLL_LIQUIDATIONS,
  FLAG_TOLL_LIQUIDATION_ACTIVITY,
  GET_ITINERARY_TOLL_LIQUIDATION,
  GET_ITINERARY_TOLL_LIQUIDATION_DETAIL,
  FLAG_ITINERARY_TOLL_LIQUIDATION_DETAIL_ACTIVITY,
  GET_TOLL_LIQUIDATION,
  GET_TOLL_LIQUIDATIONS,
  FLAG_GETTING_TOLL_LIQUIDATION_DIFFENCE_REASONS,
  GET_TOLL_LIQUIDATION_DIFFENCE_REASONS,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  itineraryToll: Immutable.Map({
    content: Immutable.List(),
    detail: Immutable.Map(),
    activity: Immutable.List(),
  }),
  differenceReason: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_TOLL_LIQUIDATIONS:
      return state.setIn(['all', 'loading'], payload);
    case GET_TOLL_LIQUIDATIONS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_TOLL_LIQUIDATIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_TOLL_LIQUIDATION:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_TOLL_LIQUIDATION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_TOLL_LIQUIDATION_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_TOLL_LIQUIDATION:
      return state.setIn(
        ['itineraryToll', 'content'],
        Immutable.List(payload || []),
      );
    case CLEAR_ITINERARY_TOLL_LIQUIDATION:
      return state.setIn(
        ['itineraryToll', 'content'],
        INITIAL_STATE.getIn(['itineraryToll', 'content']),
      );
    case GET_ITINERARY_TOLL_LIQUIDATION_DETAIL:
      return state.setIn(['itineraryToll', 'detail'], Immutable.Map(payload));
    case CLEAR_ITINERARY_TOLL_LIQUIDATION_DETAIL:
      return state.setIn(
        ['itineraryToll', 'detail'],
        INITIAL_STATE.getIn(['itineraryToll', 'detail']),
      );
    case FLAG_ITINERARY_TOLL_LIQUIDATION_DETAIL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['itineraryToll', 'activity'],
          state.getIn(['itineraryToll', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['itineraryToll', 'activity'],
        state.getIn(['itineraryToll', 'activity']).pop(),
      );
    case FLAG_GETTING_TOLL_LIQUIDATION_DIFFENCE_REASONS:
      return state.setIn(['differenceReason', 'loading'], payload);
    case GET_TOLL_LIQUIDATION_DIFFENCE_REASONS:
      return state.setIn(
        ['differenceReason', 'content'],
        Immutable.Map(payload),
      );
    default:
      return state;
  }
};
